import {Form, FormFeedback, FormGroup, Label, Input, Button} from "reactstrap";
import Logo from '../../assets/images/BX-LOGO.svg'
import {useState} from "react";
import {useMutation} from "@tanstack/react-query";
import {toast} from "react-toastify";
import { useNavigate } from 'react-router-dom'
import {passwordReset} from "../../api/api";


function PasswordReset() {

    const [email, setEmail] = useState("");
    const navigate = useNavigate()
    const passwordResetMutation = useMutation({
        mutationFn: passwordReset,
        onSuccess: (data, variables) =>{
            setEmail('')
            navigate("/reset-password-email-sent",{
                state:{email}
                }
            );
            toast.success('Password Reset Link Sent')
        },
        onError: err => {
            toast.error(`An error occurred! ${err?.response?.data?.detail}`)
        }
    })

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append("email", email);
        passwordResetMutation.mutate(formData)
    };

    return (
        <>
            <div className="account-pages mt-5 mb-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-8 col-lg-6 col-xl-5">
                            <div className="card">
                                <div className="card-body p-4">
                                    <div className="text-center w-75 m-auto">
                                        <span>
                                            <img
                                                src={Logo}
                                                width="73"
                                                height="56"
                                                alt={Logo}/>
                                        </span>
                                        <p className="text-muted mb-4 mt-3">
                                            Enter your email address to reset your password.
                                        </p>

                                    </div>

                                    <Form onSubmit={handleSubmit} >
                                        <FormGroup className="form-group mb-3">
                                            <Label for="email-address">
                                                Email address
                                                <span className="text-danger">*</span>
                                            </Label>
                                            < Input
                                                className="form-control"
                                                type="email"
                                                id="email-address"
                                                value={email}
                                                placeholder="Enter your email"
                                                invalid={
                                                    passwordResetMutation.isError &&
                                                    passwordResetMutation.error.response.data.email
                                                }
                                                onChange={(e) =>
                                                    setEmail(e.target.value)
                                                }
                                                />
                                            <FormFeedback invalid>
                                                {
                                                    passwordResetMutation.isError &&
                                                    passwordResetMutation.error.response.data.email}
                                            </FormFeedback>
                                        </FormGroup>
                                        <FormGroup>
                                            <Button type="submit"
                                                    className="btn bx-btn-primary btn-block waves-effect waves-light mt-2"

                                            >
                                                Reset Password
                                            </Button>
                                        </FormGroup>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PasswordReset;